module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_combo_simple_rec_motivo_2.d001c2e0.png";